import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { convertToCurrencyFormat } from "../../helpers/Utils";
import { PAYMENT_TYPES, PAYMENT_TYPE } from "../../actions";
import StaticLogo from "../../shared/images/common/logo.png";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const accountantNameInstituteIds = [15976];

class Receipt extends PureComponent {
  renderHeader(feeAccount) {
    const { institute } = this.props;
    return (
      <div style={{ borderBottom: "2px solid gray", paddingBottom: 5 }}>
        <div style={{ position: "absolute", width: "15%" }}>
          <img
            alt=""
            src={institute.picture.url || StaticLogo}
            style={{
              display: "block",
              width: "auto",
              height: "auto",
              objectFit: "contain",
              maxWidth: "100%",
              maxHeight: 120,
            }}
          />
        </div>
        <div
          style={{
            fontSize: 25,
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {feeAccount.name}
        </div>
        {!!feeAccount.address && (
          <div
            style={{
              fontSize: 14,
              textAlign: "center",
            }}
          >
            {feeAccount.address}
          </div>
        )}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            marginTop: 5,
          }}
        >
          {!!feeAccount.gst_number && (
            <div style={{ marginTop: 5, fontSize: 14 }}>
              <div>
                <span style={{ fontWeight: "bold" }}>GSTIN: </span>
                {feeAccount.gst_number}
              </div>
            </div>
          )}
          {!!institute.website && (
            <div style={{ marginTop: 5, fontSize: 14 }}>
              <div>
                <span style={{ fontWeight: "bold" }}>Website: </span>
                {institute.website}
              </div>
            </div>
          )}
          {institute.contact_email && institute.contact_email != "null" && (
            <div style={{ marginTop: 5, fontSize: 14 }}>
              <div>
                <span style={{ fontWeight: "bold" }}>E-Mail: </span>
                {institute.contact_email}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderHeaderRazor(student) {
    const { institute } = this.props;
    return (
      <div style={{ borderBottom: "2px solid gray", paddingBottom: 5 }}>
        <div style={{ position: "absolute", width: "15%" }}>
          <img
            alt=""
            src={institute.picture.url || StaticLogo}
            style={{
              display: "block",
              width: "auto",
              height: "auto",
              objectFit: "contain",
              maxWidth: "100%",
              maxHeight: 120,
            }}
          />
        </div>
        <div
          style={{
            fontSize: 25,
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {student.first_name}
        </div>
        {!!student.address && (
          <div
            style={{
              fontSize: 14,
              textAlign: "center",
            }}
          >
            {student.address}
          </div>
        )}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            marginTop: 5,
          }}
        >
          {!!student.gst_number && (
            <div style={{ marginTop: 5, fontSize: 14 }}>
              <div>
                <span style={{ fontWeight: "bold" }}>GSTIN: </span>
                {student.gst_number}
              </div>
            </div>
          )}
          {!!institute.website && (
            <div style={{ marginTop: 5, fontSize: 14 }}>
              <div>
                <span style={{ fontWeight: "bold" }}>Website: </span>
                {institute.website}
              </div>
            </div>
          )}
          {institute.contact_email && institute.contact_email != "null" && (
            <div style={{ marginTop: 5, fontSize: 14 }}>
              <div>
                <span style={{ fontWeight: "bold" }}>E-Mail: </span>
                {institute.contact_email}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderStudentInfo(receipt) {
    const { student, paymentDate, feeGroup } = this.props;
    const user = cookies.get("user");
    return (
      <>
        <div
          style={{
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ paddingTop: "2px" }}>
            <span style={{ fontWeight: "bold", paddingTop: "2px" }}>
              Student ID:{" "}
            </span>
            {student.badge_id}
          </div>
          <div>
            <span style={{ fontWeight: "bold", paddingTop: "2px" }}>
              Date:{" "}
            </span>
            {paymentDate}
          </div>
        </div>
        <div
          style={{
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ paddingTop: "3px" }}>
            <span style={{ fontWeight: "bold" }}>Student Name: </span>
            {student.first_name}
          </div>
          <div style={{ paddingTop: "3px" }}>
            <span style={{ fontWeight: "bold" }}>Receipt No.: </span>
            {receipt}
          </div>
        </div>
        <div
          style={{
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ paddingTop: "3px", fontSize: 14 }}>
            <span style={{ fontWeight: "bold" }}>Father's Name: </span>
            {student.father_name || "-"}
          </div>
          <div style={{ paddingTop: "3px", fontSize: 14 }}>
            <span style={{ fontWeight: "bold" }}>Father's Phone: </span>
            {student.father_phone || "-"}
          </div>
        </div>
        <div
          style={{
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ paddingTop: "3px", fontSize: 14 }}>
            <span style={{ fontWeight: "bold" }}>Classroom: </span>
            {student.classroom_name}
          </div>
        </div>
        <div
          style={{
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {accountantNameInstituteIds.includes(user.institute_id) && (
            <div style={{ paddingTop: "3px", fontSize: 14 }}>
              <span style={{ fontWeight: "bold" }}>Accountant Name: </span>
              {feeGroup[0].accountant_name}
            </div>
          )}
          <div style={{ paddingTop: "3px", fontSize: 14 }}>
            <span style={{ fontWeight: "bold" }}>Tags: </span>
            {student.student_tags
              ? student.student_tags.map((tag) => {return tag.label;}).join(", ")
              : "-"}
          </div>
        </div>
      </>
    );
  }

  renderStudentInfoRazor(student, receipt) {
    const { paymentDate, feeGroup } = this.props;
    return (
      <>
        <div
          style={{
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ paddingTop: "2px" }}>
            <span style={{ fontWeight: "bold", paddingTop: "2px" }}>
              Student ID:{" "}
            </span>
            {student.badge_id}
          </div>
          <div>
            <span style={{ fontWeight: "bold", paddingTop: "2px" }}>
              Date:{" "}
            </span>
            {paymentDate}
          </div>
        </div>
        <div
          style={{
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ paddingTop: "3px" }}>
            <span style={{ fontWeight: "bold" }}>Student Name: </span>
            {student.first_name}
          </div>
          <div style={{ paddingTop: "3px" }}>
            <span style={{ fontWeight: "bold" }}>Receipt No.: </span>
            {receipt}
          </div>
        </div>
        <div
          style={{
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ paddingTop: "3px", fontSize: 14 }}>
            <span style={{ fontWeight: "bold" }}>Father's Name: </span>
            {student.father_name}
          </div>
          <div style={{ paddingTop: "3px", fontSize: 14 }}>
            <span style={{ fontWeight: "bold" }}>Classroom: </span>
            {student.classroom_name}
          </div>
        </div>
      </>
    );
  }

  renderTable() {
    const { feeGroup } = this.props;
    let filteredDues =
      feeGroup &&
      feeGroup.map((fee) => {
        return {
          ...fee,
          amount: Math.ceil(
            (Number(fee.payment) * 100) / (Number(fee.tax) + 100)
          ),
        };
      });
    const totalAmount = filteredDues.reduce(
      (sum, fee) => sum + Number(fee.amount),
      0
    );
    const totalGst = filteredDues.reduce(
      (sum, fee) => sum + Number(fee.payment - fee.amount),
      0
    );
    const totalPayment = filteredDues.reduce(
      (sum, fee) => sum + Number(fee.payment),
      0
    );
    return (
      <div
        style={{ flex: 1, display: "flex", margin: "20px 0px", fontSize: 14 }}
      >
        <style>
          {`
          table {
            border-spacing: 0;
          }
          th {
            padding: 7px;
            border-bottom: 1px solid gray;
          }
          td {
            padding: 7px;
            text-align: center;
          }
        `}
        </style>
        <table
          style={{
            flex: 1,
            borderSpacing: 0,
            borderTop: "1px solid gray",
            borderBottom: "1px solid gray",
          }}
        >
          <thead>
            <tr style={{ borderBottom: "1px solid gray" }}>
              <th>S.NO</th>
              <th style={{ textAlign: "left" }}>Fee Item</th>
              <th style={{ textAlign: "left" }}>Mode</th>
              <th style={{ textAlign: "right" }}>Amount</th>
              <th style={{ textAlign: "left" }}>GST%</th>
              <th style={{ textAlign: "left" }}>GST</th>
              <th style={{ textAlign: "right" }}>Total Amount</th>
            </tr>
          </thead>
          <tbody>
            {filteredDues.map((fee, index) => (
              <tr key={fee.fee_due_id}>
                <td>{index + 1}</td>
                <td style={{ textAlign: "left" }}>{fee.name}</td>
                <td style={{ textAlign: "left" }}>
                  <div>
                    {Object.keys(PAYMENT_TYPE).find(
                      (type) => PAYMENT_TYPE[type] === Number(fee.payment_type)
                    )}
                  </div>
                  {[
                    PAYMENT_TYPES.CHEQUE,
                    PAYMENT_TYPES.DD,
                    PAYMENT_TYPES.CONCESSION,
                    PAYMENT_TYPES.FEE_REDUCTION,
                    PAYMENT_TYPES.CARD,
                    PAYMENT_TYPES.ONLINE_TRANSFER,
                    PAYMENT_TYPES.CASH_DEPOSIT,
                  ].includes(fee.payment_type) && (
                    <div style={{ fontSize: 14 }}>
                      {fee.payment_type ===
                      (PAYMENT_TYPES.CONCESSION || PAYMENT_TYPES.FEE_REDUCTION)
                        ? "Reason: "
                        : fee.payment_type === PAYMENT_TYPES.CARD
                        ? "Card No: "
                        : fee.payment_type === PAYMENT_TYPES.CHEQUE
                        ? "Cheque No: "
                        : fee.payment_type === PAYMENT_TYPES.ONLINE_TRANSFER ||
                          fee.payment_type === PAYMENT_TYPES.CASH_DEPOSIT
                        ? "Ref No:"
                        : "DD No: "}
                      {fee.payment_type === PAYMENT_TYPES.CHEQUE
                        ? fee.cheque_number
                        : fee.payment_type === PAYMENT_TYPES.DD
                        ? fee.dd_number
                        : fee.payment_type === PAYMENT_TYPES.CARD
                        ? fee.card_no
                        : fee.payment_type === PAYMENT_TYPES.CONCESSION
                        ? fee.concession_reason
                        : fee.payment_type === PAYMENT_TYPES.ONLINE_TRANSFER ||
                          fee.payment_type === PAYMENT_TYPES.CASH_DEPOSIT
                        ? fee.ref_no
                        : fee.fee_reduction_reason}
                    </div>
                  )}
                </td>
                <td style={{ textAlign: "right" }}>
                  {convertToCurrencyFormat(fee.amount)}
                </td>
                <td style={{ textAlign: "left", fontSize: 13 }}>
                  <div>CGST: {fee.tax / 2}%</div>
                  SGST: {fee.tax / 2}%
                </td>
                <td style={{ textAlign: "left", fontSize: 13 }}>
                  <div>
                    CGST:{" "}
                    {convertToCurrencyFormat((fee.payment - fee.amount) / 2)}
                  </div>
                  SGST:{" "}
                  {convertToCurrencyFormat((fee.payment - fee.amount) / 2)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {convertToCurrencyFormat(fee.payment)}
                </td>
              </tr>
            ))}
            <tr>
              <td style={{ borderTop: "1px solid gray" }}></td>
              <td
                style={{
                  borderTop: "1px solid gray",
                  fontWeight: "bold",
                  textAlign: "left",
                }}
              >
                Total
              </td>
              <td style={{ borderTop: "1px solid gray" }}></td>
              <td style={{ borderTop: "1px solid gray", textAlign: "right" }}>
                {convertToCurrencyFormat(totalAmount)}
              </td>
              <td style={{ borderTop: "1px solid gray" }}></td>
              <td style={{ borderTop: "1px solid gray", textAlign: "left" }}>
                {convertToCurrencyFormat(totalGst)}
              </td>
              <td style={{ borderTop: "1px solid gray", textAlign: "right" }}>
                {convertToCurrencyFormat(totalPayment)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderFooter() {
    return (
      <div
        style={{
          flex: 1,
          padding: 15,
          display: "flex",
          justifyContent: "center",
        }}
      >
        This is a computer generated invoice. No signature is required.
      </div>
    );
  }

  render() {
    const { feeAccountID, feeAccounts, receipt, studentData, isRazor } =
      this.props;
    const feeAccount = feeAccounts.find(
      (account) => Number(account.id) === Number(feeAccountID)
    );
    return (
      <div
        style={{
          height: "148mm",
          width: "210mm",
          background: "white",
        }}
      >
        <div style={{ padding: "10mm" }}>
          {feeAccount
            ? this.renderHeader(feeAccount)
            : this.renderHeaderRazor(studentData)}

          <div
            style={{
              fontSize: 20,
              fontWeight: "bold",
              margin: "15px 0px 0px 0px",
              textAlign: "center",
            }}
          >
            FEE RECEIPT
          </div>
          {!isRazor
            ? this.renderStudentInfo(receipt)
            : this.renderStudentInfoRazor(studentData, receipt)}
          {this.renderTable()}
          <div
            style={{
              flex: 1,
              display: "flex",
            }}
          >
            {this.renderFooter()}
          </div>
        </div>
      </div>
    );
  }
}

Receipt.propTypes = {
  feeGroup: PropTypes.array,
  student: PropTypes.object,
  paymentDate: PropTypes.string.isRequired,
  feeAccounts: PropTypes.array,
  feeAccountID: PropTypes.number,
  studentData: PropTypes.object,
};

Receipt.defaultProps = {
  feeGroup: [],
  student: {},
  feeAccounts: [],
  feeAccountID: null,
  studentData: {},
};

const mapStateToProps = ({ student, home }) => ({
  student,
  feeAccounts: home.feeAccounts,
});

export default connect(mapStateToProps, {})(Receipt);
